<template>
  <div v-loading="allLoading">
    <el-row>
      <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline">
        
        <el-form-item label="员工姓名">
          <el-input v-model="formInline.empName" style="width:145px" placeholder="请输入员工姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input v-model="formInline.IdCard" style="width:145px" placeholder="请输入证件号码">
          </el-input>
        </el-form-item>
        <el-form-item label="所属机构">
          <el-select v-model="formInline.orgId" placeholder="请选择机构" clearable>
            <el-option
              v-for="item in cusOrgList"
              :key="item.id"
              :label="item.orgName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startDate" label="开始时间" :rules="[{ required: true, message: '请选择开始时间', trigger: 'blur' },]">
          <el-date-picker v-model="formInline.startDate" style="width:145px" type="month" value-format="yyyy-MM"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endDate" label="结束时间" :rules="[{ required: true, message: '请选择结束时间', trigger: 'blur' },]">
          <el-date-picker v-model="formInline.endDate" style="width:145px" type="month" value-format="yyyy-MM"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toColumnPage">自定义表头</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    
    <div ref="payrollSetting">
      <div style="height: calc(100vh - 212px);">
        <el-tabs v-model="tabIndex" @tab-click="clickTabs" type="card" style="height: calc(100vh - 80px);">
          
          <el-tab-pane
            :key="item.taxType"
            v-for="(item, index) in dataList.dataList"
            :label="item.taxType"
            :name="'tab'+index"
          >
            <span slot="label">{{item.taxType| bspTableFilter({'1':'dict', '2':dicts})}}</span>
            <div class="gridContain" style="height:calc(100vh - 310px);border: 1px salmon">
              <vxe-grid
                border
                show-footer
                :optimization="{scrollX: {gt: -1}}"
                :show-overflow="true"
                :show-header-overflow="true"
                keep-source
                resizable
                :loading="loading"
                auto-resize
                width="100%"
                height="100%"
                :footer-method="footerMethod"
                :custom-config="{storage: true}"
                highlight-hover-row
                ref="table"
                :data="item.data"
              >
                <vxe-table-column v-for="(column,i) in dataList.customList" :key='i' width="120px"
                                  :title="column.columnName" align="center" :field="column.field"
                                  :fixed="column.field=='empName'||column.field=='idCard'||column.field=='wageMonth'?'left':''">
                  <template v-if="column.codeSetId && column.codeSetId !=''" v-slot="{ row}">
                          <span>
                              <span>{{ row[column.field]| bspTableFilter({'1':'dict', '2':dicts})}}</span>
                          </span>
                  </template>
                  <template v-else v-slot="{ row}">
                          <span>
                              <span>{{ row[column.field]}}</span>
                          </span>
                  </template>
                </vxe-table-column>
                <template v-slot:empty>
                    <span>
                      <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                            <use xlink:href="#icon-kong"></use>
                          </svg>
                      <p class="noData">暂无数据</p>
                    </span>
                </template>
              </vxe-grid>
            </div>
            <vxe-pager
              :loading="loading"
              :current-page="formInline.page"
              :page-size="formInline.limit"
              :total="formInline.total"
              :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
              @page-change="handlePageChange">
            </vxe-pager>
          
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog
        ref=""
        id="dialog1"
        width="740px"
        v-loading="loading"
        v-dialogDrag
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="自定义表头"
        :visible.sync="dialogheaderVisibleHeaders"
      >
        <customHeader
          :headerType="headerType"
          :headerList.sync="headerList"
          :templateId="templateIdRoute"
          :batchId="batchIdRoute">
        
        </customHeader>
        <div
          class="marginTop30"
          style="text-align: center"
        >
          <el-button
            type="primary"
            @click="saveCusHeader()"
          >
            确认
          </el-button>
          <el-button @click="dialogheaderVisibleHeaders = false">
            取消
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {updataCustHeaderInfo, getPayReportDatas} from "@/api/wage/pay";
import customHeader from "@/views/wage/pay/customHeader/index";
import {commonConst} from '@/const/code.js'
import store from '@/store';
import {deepCopy} from '@/util/util';
import backBtn from '@/wage-components/back-btn/back-btn'
import {exportExcleSheets} from "@/api/common/common"
import {downloadFile} from '@/util/util';
import {bspTableFilter, dateByFormat} from '@/filters/index.js';
import {mapGetters} from 'vuex';
import XEUtils from 'xe-utils';
import {getCompanyOrg} from "@/api/org/org";
import exportMethod from '@/util/export.js'

export default {
  name: "payReport",
  props: {},
  components: {customHeader, backBtn},
  created() {
    this.toSelect();
    this._getCompanyOrg();
  },
  data() {
    let templateIdRoute = '111003'//明细报表固定tempID
    let date = dateByFormat(new Date(), 'yyyy-MM');
    
    return {
      hiddenColumns: [],
      salaryHistoryLists: [],
      tabIndex: 'tab0',
      headerList: [],//选择自定义列头保存数据
      loading: false,
      headerType: '1003',//明细报表
      formInline: {
        page: 1,
        limit: 20,
        total: 0,
        templateId: templateIdRoute,
        startDate: date,
        endDate: date,
      },
      dataList: [],
      allLoading: false,
      sumList: [],
      dialogheaderVisibleHeaders: false,
      templateIdRoute: templateIdRoute,//明细报表
      cusOrgList: [],
    }
  },
  computed: {
    ...mapGetters([
      'dicts',
      'cusId'
    ])
  },
  methods: {
    footerMethod({columns, data}) {
      this.hiddenColumns = [];
      return [
        columns.map((column, columnIndex) => {
          if (data && data.length > 0) {
            let columFiled = column.property;
            let result = XEUtils.every(data, (data) => {
              return data[columFiled] === 0 || data[columFiled] === null
            })
            if (result) {
              this.hiddenColumns.push(columFiled)
            }
          }
          
          if (columnIndex === 0) {
            return '合计'
          }
          if (this.sumList.includes(column.property)) {
            return XEUtils.sum(data, column.property)
          }
          return null
        })
      ]
    },
    backToCodeSet() {
      this.$router.go(-1)
    },
    //跳转自定义表头设置
    toColumnPage() {
      this.dialogheaderVisibleHeaders = true
    },
    //保存
    saveCusHeader() {
      if (this.headerList && this.headerList.length == 0) {
        this.$message.warning('请选择表头内容')
        return;
      }
      console.log('保存传参', this.headerList)
      let param = {
        'templateId': this.templateIdRoute,
        'headers': this.headerList,
        'headerType': this.headerType  //薪资报表
      }
      
      let value = this.tabIndex.substring(this.tabIndex.length - 1, this.tabIndex.length);
      this.loading = true;
      updataCustHeaderInfo(param).then(res => {
        this.loading = false;
        if (res.data.code == 0) {
          this.onSubmit();
          //关闭自定义页面
          this.dialogheaderVisibleHeaders = false;
          this.$message.success('自定义保存成功!');
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    onSubmit(isChange) {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.toSelect(isChange);
        } else {
          this.$message.error("请填入开始和结束时间");
          return false;
        }
      });
    },
    toSelect(isChange) {
      this.formInline['headerType'] = this.headerType
      if (isChange != 'N') {
        this.dataList = [];
        this.formInline['taxType'] = '';
        this.formInline['page'] = 1;
        this.tabIndex = 'tab0';
        this.allLoading = true;
      }
      
      //循环查找所有所属机构
      this.findOrgIds();
      
      this.loading = true;
      getPayReportDatas(this.formInline).then(res => {
        console.log(res)
        this.loading = false;
        this.allLoading = false;
        if (res.data.code == 0) {
          this.dataList = res.data.data;
          if (isChange != 'N') {
            this.sumList = this.dataList.sumList;
            this.formInline.total = this.dataList.dataList[0].num
          }
        }
      })
    },
    findOrgIds() {
      //循环查找所有所属机构
      if (this.formInline.orgId && this.formInline.orgId != '') {
        let selectList = [];
        selectList.push(this.formInline.orgId);
        
        for (let i = 0; i < selectList.length; i++) {
          let item = selectList[i];
          let selOrg = this.cusOrgList.filter(select => {
            return select.supId == item
          })
          if (selOrg && selOrg.length > 0) {
            selOrg.forEach(sel => {
              selectList.push(sel.id);
            })
          }
        }
        //数组去重
        selectList = selectList.filter((value, index, arr) => arr.indexOf(value) === index);
        this.formInline['orgIds'] = selectList;
      } else {
        this.formInline['orgIds'] = [];
      }
    },
    handlePageChange({currentPage, pageSize}) {
      this.formInline.page = currentPage;
      this.formInline.limit = pageSize;
      this.onSubmit('N');
    },
    clickTabs(tabs) {
      this.formInline.total = this.dataList.dataList[tabs.index].num
      this.formInline['taxType'] = this.dataList.dataList[tabs.index].taxType;
      this.formInline.page = 1;
      
      this.onSubmit('N');
    },
    // 查询分公司
    _getCompanyOrg() {
      getCompanyOrg(this.$store.state.user.cusId).then((res) => {
        this.cusOrgList = res.data
        console.log(this.cusOrgList)
      });
    },
    toExport() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          let column = deepCopy(this.dataList.customList);
          this.findOrgIds();
          
          exportMethod(
            {
              columns: column,
              type: "excel",
              beanName: "salaryHistoryServiceImpl",
              methodName: "getPayReportDatasForExport",
              limit: this.formInline.limit,
              page: this.formInline.page,
              templateId: this.formInline.templateId,
              startDate: this.formInline.startDate,
              endDate: this.formInline.endDate,
              empName: this.formInline.empName,
              IdCard: this.formInline.IdCard,
              orgIds: this.formInline.orgIds,
              headerType: this.headerType,
              headerRowNum: 1,
              isSort: true,
              fileName: "雇员发薪明细表.xls",
            },
            "/wage", true
          );
        } else {
          this.$message.error("请填入开始和结束时间");
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>
.customerBox >>> .el-tabs__new-tab {
  position: relative;
  top: -6px;
}

.btnCon {
  position: absolute;
  right: 0;
  top: -32px;
}

.el-loading-spinner {
  display: block;
}

.light-theme #main > div.customerBox:not(.home) {
  background: transparent;
  padding: 0;
  box-shadow: none;
}

.tooltip {
  width: 200px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  margin-right: 10px;
  font-size: 12px;
  color: #333;
}

.tooltip .icon {
  color: red;
  margin-right: 4px;
}

.gridContain >>> .vxe-body--row .vxe-cell {
  height: 100%;
  padding: 0;
  line-height: 46px;
}

</style>
